import React from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';
import ProfileDropDown from '@client/components/navigation/ProfileDropDown';
import { LoginSvg } from '@client/components/icons/loginSvg/LoginSvg';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { useLocation } from 'react-router-dom';
import { trackCustomEvent } from '@client/tracking/GTM';
import {
  EVENT_GA,
  CATEGORY_NAVIGATION,
  ACTION_LINK_CLICK,
} from '@client/definitions/tracking';
import { LOGIN, HLF_LINK_TEXT } from '@client/definitions/constants';
import styles from './topNavigation.scss';

export const TopNavigation = () => {
  const auth = useAuth0();
  const location = useLocation();
  const authenticated = auth?.isAuthenticated;

  const handleLogin = (name) => {
    auth?.loginWithRedirect({
      appState: { targetUrl: location?.pathname },
    });
    trackNavigationClick(name);
  };

  const trackNavigationClick = (name) => {
    trackCustomEvent(EVENT_GA, {
      click_category: CATEGORY_NAVIGATION,
      click_type: ACTION_LINK_CLICK,
      click_text: name,
    });
  };

  return (
    <div className={styles.topNavigation}>
      <ReactLink
        className={styles.link}
        target="_blank"
        to="https://www.hjart-lungfonden.se"
        onClick={() => trackNavigationClick(HLF_LINK_TEXT)}
      >
        {HLF_LINK_TEXT}
      </ReactLink>
      {!authenticated && (
        <button className={styles.loginBtn} onClick={() => handleLogin(LOGIN)}>
          <LoginSvg />
          <span className={styles.link}>{LOGIN}</span>
        </button>
      )}
      {authenticated && <ProfileDropDown />}
    </div>
  );
};
